import {
  GraphQLObjectType,
  GraphQLNonNull,
  GraphQLID,
  GraphQLBoolean,
  GraphQLInt,
  GraphQLString,
  GraphQLFloat
} from 'graphql';

import Node from './node.gql';
import SuccessStatusEnumType from './enums/successStatus.gql';
import CompletionStatusEnumType from './enums/completionStatus.gql';
import ScormType from './scorm.gql';

const CompletionStatusEnum = {
  complete: 'COMPLETE',
  inComplete: 'IN_COMPLETE',
  notAttempted: 'NOT_ATTEMPTED'
};

const SuccessStatusEnum = {
  pass: 'PASS',
  fail: 'FAIL',
  na: 'NA'
};

const cardPerformanceType = new GraphQLObjectType({
  name: 'CardPerformance',
  fields: () => ({
    id: {
      type: new GraphQLNonNull(GraphQLID)
    },
    pid: {
      type: GraphQLString
    },
    complete: {
      type: GraphQLBoolean
    },
    forceComplete: {
      type: GraphQLBoolean
    },
    read: {
      type: GraphQLBoolean
    },
    timeSpent: {
      type: GraphQLInt,
      resolve: root => Math.ceil(root.timeSpent)
    },
    dirtyTimeSpent: {
      type: GraphQLBoolean
    },
    dirtyComplete: {
      type: GraphQLBoolean
    },
    dirtyProgressMeasure: {
      type: GraphQLBoolean
    },
    lastUpdatedTimeSpent: {
      type: GraphQLString
    },
    lastUpdatedComplete: {
      type: GraphQLString
    },
    lastUpdated: {
      type: GraphQLString
    },
    progressMeasure: {
      type: GraphQLFloat
    },
    scaledProgressMeasure: {
      type: GraphQLFloat
    },
    completionStatus: {
      type: CompletionStatusEnumType,
      resolve: root => CompletionStatusEnum[root.completionStatus]
    },
    successStatus: {
      type: SuccessStatusEnumType,
      resolve: root => SuccessStatusEnum[root.successStatus]
    },
    lastSubmittedOn: {
      type: GraphQLString
    },
    blockPerformance: {
      type: GraphQLString,
      resolve: root => root.blockPerformance || '{}'
    },
    rawScore: {
      type: GraphQLFloat,
      resolve: root => (root.rawScore ? root.rawScore : 0)
    },
    scaledScore: {
      type: GraphQLFloat,
      resolve: root => (root.scaledScore ? root.scaledScore : 0)
    },
    actualSubmit: {
      type: GraphQLBoolean,
      resolve: root => !!root.actualSubmit
    },
    scorm: {
      type: ScormType
    },
    reAttemptCount: {
      type: GraphQLInt,
      resolve: root => (root.reAttemptCount ? root.reAttemptCount : 0)
    }
  }),
  interfaces: [Node.nodeInterface]
});

window[cardPerformanceType.name + 'GQLType'] = cardPerformanceType;

export default cardPerformanceType;
